import { useFormik } from 'formik';
import * as Yup from 'yup';

const InviteOwnerSchema = Yup.object().shape({
  f_name: Yup.string().required('First name is required'),
  l_name: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email').required('Email is required')
});

export default function useInviteOwnerFormik(onSubmit) {
  const formik = useFormik({
    initialValues: { f_name: '', l_name: '', dob: '', gender: '', email: '', phone: '' },
    validationSchema: InviteOwnerSchema,
    onSubmit
  });

  return formik;
}
